// extracted by mini-css-extract-plugin
module.exports = {"Label":"QuestionPreview_Label__3J5MB","Input":"QuestionPreview_Input__t6EP0","Textarea":"QuestionPreview_Textarea__Jhr7c","check":"QuestionPreview_check__2f_-e"};